module.exports = {
    "Terminal Programları": "Terminal Programları",
    "menu.KullaniciVeRolYonetimi": "Kullanıcı ve Rol Yönetimi",
    "menu.KullaniciYonetimi": "Kullanıcı Yönetimi",
    "menu.KullaniciRolYonetimi": "Kullanıcı Rol Yönetimi",
    "menu.YetkiGrupYonetimi": "Yetki Grup Yönetimi",

    "1- Araç Sorgulama": "1- Araç Sorgulama",
    "2- Liman Giriş": "2- Liman Giriş",
    "3- Limandan Depoya Sevkiyat": "3- Limandan Depoya Sevkiyat",
    "4- Tekli Grupaj Tır Eşleme": "4- Tekli Grupaj Tır Eşleme",
    "5- Depolar Arası Transfer": "5- Depolar Arası Transfer",
    "6- Depo Giriş": "6- Depo Giriş",
    "7- Gemi Araç Giriş": "7- Gemi Araç Giriş",
    "8- Antrepo Çıkış": "8- Antrepo Çıkış",
    "9- PDI Giriş": "9- PDI Giriş",
    "10- PDI Dönüş": "10- PDI Dönüş",
    "11- PDI Yapılmayacak": "11- PDI Yapılmayacak",
    "12- Gümrüklü Alan'a İade": "12-  Gümrüklü Alan'a İade",
    "13- PDI Çıkış": "13- PDI Çıkış",
    "14- Hasarlıdan Çıkış": "14- Hasarlıdan Çıkış",
    "15- Sevk Alanına Transfer": "15- Sevk Alanına Transfer",
    "16- Peron Kontrol": "16- Peron Kontrol",
    "17- Şase İle Kapı Çıkış": "17- Şase İle Kapı Çıkış",
    "18- Tır Onay": "18- Tır Onay",
    "19- Depo Çıkış": "19- Depo Çıkış",
    "20- Otomatik Adres Değiştir": "20- Otomatik Adres Değiştir",
    "21- Yerinde Adresleme": "21- Yerinde Adresleme",
    "22- Sayım": "22- Sayım",
    "23- Yazıcı Seçimi": "23- Yazıcı Seçimi",
    "24- Etiket Yazdır": "24- Etiket Yazdır",

    "sifremiDegistir": "Şifremi Değiştir",
    "cikisYap": "Çıkış Yap",

    "Araç Bilgileri": "Araç Bilgileri",
    "Giriş-Çıkış Tarihleri": "Giriş-Çıkış Tarihleri",
    "Araç Hareketleri": "Araç Hareketleri",
    "Emirler": "Emirler",
    "Sevkiyet Hareketleri": "Sevkiyet Hareketleri",
    "Hasarlar": "Hasarlar",
    "Blokaj": "Blokaj",
    "Tarihçe": "Tarihçe",
    "Şase": "Şase",
    "Bul": "Bul",
    "Marka": "Marka",
    "Model": "Model",
    "PDI Durumu": "PDI Durumu",
    "Fatura Tarih": "Fatura Tarih",
    "Fatura No": "Fatura No",
    "Fatura Bayi": "Fatura Bayi",

    "Millileşme Durumu": "Millileşme Durumu",
    "Park Adres": "Park Adres",
    "Noas Ref": "Noas Ref",
    "Durum": "Durum",
    "Son Yapılan İşlem Tarihi": "Son Yapılan İşlem Tarihi",
    "Renk": "Renk",
    "Son İşlem": "Son İşlem",

    "No Data": "Veri Yok",

    "Türkiye Liman Giriş": "Türkiye Liman Giriş",
    "Türkiye Liman Çıkış": "Türkiye Liman Çıkış",
    "Antrepo Giriş": "Antrepo Giriş",
    "Antrepo Çıkış": "Antrepo Çıkış",
    "Son Depo Giriş": "Son Depo Giriş",
    "Son Depo Çıkış": "Son Depo Çıkış",

    "Şase Sorgulama": "Şase Sorgulama",

    "Tarih": "Tarih",
    "Hareket Tipi": "Hareket Tipi",
    "HareketKodu": "Hareket Kodu",
    "HareketAdı": "Hareket Adı",
    "Nereden": "Nereden",
    "Nereye": "Nereye",
    "BulunduguAdres": "Bulunduğu Adres",
    "GittigiYer": "Gittiği Yer",
    "ParkSoforu": "Park Şoförü",
    "IslemYapanKullanici": "İşlem Yapan Kullanıcı",

    "Giriş Tarih": "Giriş Tarih",
    "Gerçekleşme": "Gerçekleşme",
    "Emir Kodu": "Emir Kodu",
    "Emir Adı": "Emir Adı",
    "Emir Durumu": "Emir Durumu",
    "Emir Oluşturan": "Emir Oluşturan",

    "GrupajNo": "Grupaj No",
    "Rota": "Rota",
    "Grupaj Tarih": "Grupaj Tarih",
    "Kapı Çıkış Tarih": "Kapı Çıkış Tarih",
    "Taşıyıcı": "Taşıyıcı",
    "Tır Plaka": "Tır Plaka",
    "Şoför": "Şoför",
    "Grupaj Statü": "Grupaj Statü",
    "Fatura Tarihi": "Fat. Trh.",

    "Hasar Giriş": "Hasar Giriş",
    "İşlem Tarihi": "İşlem Tarihi",
    "Hasar Yeri": "Hasar Yeri",
    "Hasar Detay": "Hasar Detay",
    "Hasar Sorumlusu": "Hasar Sorumlusu",
    "Hasar Durumu": "Hasar Durumu",
    "Kaydı Oluşturan": "Kaydı Oluşturan",

    "Blokaj No": "Blokaj No",
    "Blokaj Açıklama": "Blokaj Açıklama",
    "Aktif/Pasif": "Aktif/Pasif",
    "Kodlama Tarihi": "Kodlama Tarihi",
    "Kodlayan": "Kodlayan",
    "Kaldırma Tarihi": "Kaldırma Tarihi",
    "İptal Eden": "İptal Eden",

    "Dosya Adı": "Dosya Adı",
    "Yükleme Tarih": "Yükleme Tarih",
    "Yükleyen": "Yükleyen",
    "Durum Kodu": "Durum Kodu",
    "Durum Açıklama": "Durum Açıklama",
    "Olay Adı": "Olay Adı",

    "Operasyonlar": "Operasyonlar",

    "Araç Sorgulama": "Araç Sorgulama",
    "Şase No Giriniz": "Şase No Giriniz",

    "Tamam": "Tamam",
    "Liman Giriş": "Liman Giriş",
    "Ara": "Ara",

    "Operasyon İzleme": "Operasyon İzleme",
    "Excel Toplu İşlemler": "Excel Toplu İşlemler",
    "Hasar Bildirimi": "Hasar Bildirimi",
    "Gemi İşlemleri": "Gemi İşlemleri",
    "Stok İzleme": "Stok İzleme",

    "Hasar Açıklama": "Hasar Açıklama",
    "Bölge": "Bölge",
    "Bildiren Kişi": "Bildiren Kişi",
    "Hasar Görseli": "Hasar Görseli",

    "Hasar Bildir": "Hasar Bildir",
    "Listele": "Listele",

    "PDI Giriş": "PDI Giriş",
    "PDI Dönüş": "PDI Dönüş",
    "PDI Çıkış": "PDI Çıkış",

    "Etiket Yazdır": "Etiket Yazdır",
    "PDI Yapılmayacak": "PDI Yapılmayacak",
    "Rıhtım'a İade": "Rıhtım'a İade",

    "Hasarlıdan Çıkış": "Hasarlıdan Çıkış",
    "Sevke Hazırlama": "Sevke Hazırlama",

    "Yazıcı Seçimi": "Yazıcı Seçimi",
    "Çalıştığınız Depo": "Çalıştığınız Depo",
    "Kullanılan Yazıcı Seçiniz": "Kullanılan Yazıcı Seçiniz",
    "Kaydet": "Kaydet",

    "Peron Kontrol": "Peron Kontrol",
    "Gemi Araç Giriş": "Gemi Araç Giriş",

    "Toplam Stok": "Toplam Stok",
    "Faturlanmış / Sevk Emri Olan": "Faturlanmış / Sevk Emri Olan",
    "Faturalanmamış / Sevk Emri Olmayan": "Faturalanmamış / Sevk Emri Olmayan",
    "Blokajlı": "Blokajlı",

    "Sevk Edilebilir Araç Sayısı": "Sevk Edilebilir Araç Sayısı",

    "Depo": "Depo",

    "Bayi Sevk": "Bayi Sevk",
    "Depolar Arası Transfer": "Depolar Arası Transfer",
    "Son 7 Gün Depo Çıkış Adetleri": "Son 7 Gün Depo Çıkış Adetleri",

    "Grupaj Operasyonları": "Grupaj Operasyonları",
    "Grupaj Operasyonları Detay": "Grupaj Operasyonları Detay",

    "Depo Çıkış": "Depo Çıkış",
    "Grupaj No Giriniz": "Grupaj No Giriniz",

    "Hasar Tarihi": "Hasar Tarihi",
    "Hasar Bildirilen Bölge": "Hasar Bildirilen Bölge",
    "İptal": "İptal",

    "Faturalanmış / Sevk Emri Olan": "Faturalanmış / Sevk Emri Olan",

    "equal": "Eşittir",
    "greaterThan": "Büyüktür",
    "greaterThanOrEqual": "Büyük veya eşittir",
    "lessThan": "Küçüktür",
    "lessThanOrEqual": "Küçük veya eşittir",
    "notContains": "İçermez",
    "notEqual": "Eşit değil",
    "startswith": "İle başlar",
    "endsWith": "İle biter",
    "between": "Arasında",
    "contains": "İçerir",
    "tümü": "(Tümü)",
    "Filtrele": "Filtrele",

    "Yüklemek İstediğiniz Excel Dosyasını seçiniz. Excel Şablonunu": "Yüklemek İstediğiniz Excel Dosyasını seçiniz. Excel Şablonunu",
    "buradan": "buradan",
    "indirebilirsiniz": "indirebilirsiniz",
    "Excel Dosyası Yükle": "Excel Dosyası Yükle",

    "vehicleData cannot be nil": "Araç verisi boş olamaz",
    "chassisNo number is required": "Şase numarası gereklidir",
    "chassisNo number must be 17 characters": "Şase numarası 17 karakter olmalıdır",
    "user ID is required": "Kullanıcı ID gereklidir",
    "type is required": "Tip gereklidir",
    "data is required": "Veri gereklidir",
    "no vehicle found with chassis number": "Şase numarası ile araç bulunamadı",
    "multiple vehicles found with chassis number": "Şase numarası ile birden fazla araç bulundu",

    "PDI order has not been issued for this vehicle": "Bu araç için PDI emri verilmemiştir",
    "PDI order has not been issued": "PDI emri verilmemiştir",
    "Vehicle not found": "Araç bulunamadı",
    "Invalid vehicle status": "Geçersiz araç durumu",
    "PDI entry has already been processed for this vehicle": "Bu araç için PDI girişi zaten işlenmiştir",
    "Internal server error": "Dahili sunucu hatası",

    "Yükleniyor": "Yükleniyor",


    "PDI entry not found for this vehicle": "Bu araç için PDI Girişi bulunamadı",
    "PDI entry process not completed": "PDI giriş işlemi tamamlanmadı",
    "PDI exit already processed for this vehicle": "Bu araç için PDI çıkışı zaten işlenmiştir",
    "PDI entry already processed for this vehicle": "Bu araç için PDI girişi zaten işlenmiştir",
    "invalid vehicle status": "Geçersiz araç durumu",
    "vehicle not found": "Araç bulunamadı. Şase numarasını kontrol ediniz.",
    "Beklenmedik bir hata oluştu.": "Beklenmedik bir hata oluştu.",
    "Invalid request format": "Geçersiz istek formatı",
    "multiple vehicles found with same chassis number": "Aynı şase numarasına sahip birden fazla araç bulundu",
    "merge error: PDI status is already YENI": "Bu araç için zaten aktif bir PDI emri var.",
    "failed to check vehicle existence: vehicle not found": "Araç bulunamadı",
    "merge error: PDI status is already IPTAL": "Bu araç için zaten iptal edilmiş bir PDI emri var.",

    "Kullanıcı Yönetimi": "Kullanıcı Yönetimi",
    "Ad Soyad": "Ad Soyad",
    "Kullanıcı Adı": "Kullanıcı Adı",
    "Aktif": "Aktif",
    "İşlem": "İşlem",
    "Yeni Kayıt": "Yeni Kayıt",
    "Toplam": "Toplam",
    "Yeni Kayıt Formu": "Yeni Kayıt Formu",
    "Kullanıcı Bilgileri": "Kullanıcı Bilgileri",
    "Yekilendirme": "Yetkilendirme",
    "Lütfen Ad Soyad giriniz.": "Lütfen Ad Soyad giriniz.",
    "Cinsiyet": "Cinsiyet",
    "Cinsiyet Seçiniz": "Cinsiyet Seçiniz",
    "Lütfen Kullanıcı Adı giriniz.": "Lütfen Kullanıcı Adı giriniz.",
    "Lütfen Email giriniz.": "Lütfen Email giriniz.",


    "Sadece Görme Yetkisi": "Sadece Görme Yetkisi",
    "Sadece Ekleme Yetkisi": "Sadece Ekleme Yetkisi",
    "Sadece Güncelleme Yetkisi": "Sadece Güncellem Yetkisi",
    "Sadece Silme Yetkisi": "Sadece Silme Yetkisi",
    "Sadece Excel Export Yetkisi": "Sadece Excel Export Yetkisi",
    "Tüm Özel Rolleri Kaldır": "Tüm Özel Rolleri Kaldır",

    "marked_roles": "*İşaretli roller",
    "in_selected_role_group": "'Seçilen Rol Grubunda'",
    "defined_roles": "tanımlanmış rollerdir. Seçilen diğer roller rol grubundan bağımsız kişiye",
    "special_role": "'Özel Rol'",
    "as_special_role": "olarak eklenir.",

    "Yetki Grubu Adı": "Yetki Grubu Adı",
    "Rol Adı": "Rol Adı",
    "Geri": "Geri",

    "Gruplamak için sütun başlığını buraya sürükleyin": "Gruplamak için sütun başlığını buraya sürükleyin",
    "Bu sütuna göre grupla": "Bu sütuna göre grupla",
    "Devamı için buraya tıklayın": "Devamı için buraya tıklayın",
    "Grubu çöz": "Grupu çöz",
    "Tüm grupları çöz": "Tüm grupları çöz",
    "Özel Roller": "Özel Roller",
    "Yetki Grupları": "Yetki Grupları",

    "Şifre": "Şifre",
    "Şifre Tekrarı": "Şifre Tekrarı",
    "Lütfen Şifre giriniz": "Lütfen Şifre giriniz",
    "Şifre belirlemeyecekseniz şifre alanlarını boş bırakınız.": "Şifre belirlemeyecekseniz şifre alanlarını boş bırakınız.",
    "Lütfen Şifre Tekrarı giriniz": "Lütfen Şifre Tekrarı giriniz",

    "inactive_user_message": "Girmiş olduğunuz mail sistem üzerinde",
    "inactive_user": "aktif olmayan",
    "continue_message": "bir kullanıcıya aittir. Bu kullanıcıyı aktif edip işlemlerinize devam etmek istiyorsanız",
    "activate_user": "lütfen kullanıcıyı aktif edin",
    "or_different_email": "veya farklı bir mail adresi ile işleme devam edin.",
    "İleri": "İleri",
    "Toplu Kullanıcı Yetki Grubu Atama": "Toplu Kullanıcı Yetki Grubu Atama",
    "Kullanıcı Rol Yönetimi": "Kullanıcı Rol Yönetimi",
    "Seçim": "Selection",
    "Kullanıcı Yetki Grubu Atama Formu": "Kullanıcı Yetki Grubu Atama Formu",
    "Yetki Grubu Güncelleme Formu": "Yetki Grubu Güncelleme Formu",

    "Yetki Grup Yönetimi": "Yetki Grup Yönetimi",
    "Yetki Grubu Oluştur": "Yetki Grubu Oluştur",

    "Grup Bilgileri": "Grup Bilgileri",
    "Yeni Yetki Grubu Oluşturma Formu": "Yeni Yetki Grubu Oluşturma Formu",
    "Roller": "Roller",
    "17 karakterli şase numarası giriniz": "17 karakterli şase numarası giriniz",
    "Lütfen hasar açıklaması giriniz": "Lütfen hasar açıklaması giriniz",
    "please": "Lütfen",
    "enter": "Giriniz",
    "Lütfen Adres Tarifi Giriniz": "Lütfen Adres Tarifi Giriniz",
    "Lütfen Adres Seçiniz": "Lütfen Adres Seçiniz",

    "Depo Tanım": "Depo Tanım",
    "Depo Kodu": "Depo Kodu",
    "Depo Kısa Adı": "Depo Kısa Adı",
    "Kapasite": "Kapasite",
    "Vergi Dairesi": "Vergi Dairesi",
    "Vergi No": "Vergi No",
    "Depo Ekle": "Depo Ekle",
    "Depo Adı": "Depo Adı",
    "Ekle": "Ekle",
    "Boş Olamaz": "Boş Olamaz",

    "Depo Silme Formu": "Depo Silme Formu",
    "Depo Silme Başarısız": "Depo Silme Başarısız",
    "Depo Silme Başarılı": "Depo Silme Başarılı",

    "warehouse not found or already deleted with id": "Depo bulunamadı veya zaten silinmiş",
    "Depo Ekleme Başarısız": "Depo Ekleme Başarısız",
    "Depo Ekleme Başarılı": "Depo Ekleme Başarılı",
    "Depo Güncelleme Başarısız": "Depo Güncelleme Başarısız",
    "Depo Güncelleme Başarılı": "Depo Güncelleme Başarılı",

    "cannot create zone in inactive warehouse": "Aktif olmayan depoya bölge eklenemez",

    "Adı": "Adı",
    "Geçerli": "Geçerli",
    "Bölge Kodu": "Bölge Kodu",
    "Bölge Adı": "Bölge Adı",
    "Sevke Açık Bölge": "Sevke Açık Bölge",

    "Bölge Tanım": "Bölge Tanım",
    "Bölgeden Çıkışta Form Yazdır": "Bölgeden Çıkışta Form Yazdır",
    "Bölge Ekle": "Bölge Ekle",

    "Depo Tanımları": "Depo Tanımları",
    "Bölge Tanımları": "Bölge Tanımları",

    " adet kayıt başarılı bir şekilde eklendi.": " adet kayıt başarılı bir şekilde eklendi.",
    "adet başarılı": "adet başarılı",
    "adet hatalı kayıt": "adet hatalı kayıt",

    "araç tanımlandı": "araç tanımlandı",
    "araç güncellendi": "araç güncellendi",
    "araçta hata oluştu": "araçta hata oluştu",

    "Super Admin en kapsamlı roldür. Ek role ihtiyaç yok.": "Super Admin en kapsamlı roldür. Ek role ihtiyaç yok.",
    "Girmiş olduğunuz Email sistem üzerinde aktif bir kullanıcıya aittir. Lütfen farklı bir Email giriniz.": "Girmiş olduğunuz Email sistem üzerinde aktif bir kullanıcıya aittir. Lütfen farklı bir Email giriniz.",

    "failed to check chassis number: vehicle not found": "Araç bulunamadı. Şase numarasını kotrol ediniz.",

    "Adres Değiştirme": "Adres Değiştirme",
    "Kriterler": "Kriterler",
    "Koordiant": "Koordiant",
    "Yön": "Yön",
    "Sıra": "Sıra",

    "Bu koordinat ve yön için belirtilen sıra aralığı zaten mevcut": "Bu koordinat ve yön için belirtilen sıra aralığı zaten mevcut",

    "Yerinde Adresleme": "Yerinde Adresleme",

    "Ship unload has already been processed for this vehicle": "Bu araç için okuma işlemi zaten yapılmıştır",

    "Vehicle must be of type 'ithal'": "Araç 'ithal' tipinde olmalıdır",

    "EMPTY": "BOŞ",
    "FULL": "DOLU",
    "PARTIALLY_FULL": "KISMEN DOLU",
    "OUT OF USE": "KULLANIM DIŞI",

    "boş olarak ayarlanamaz: Adres kullanımda": "boş olarak ayarlanamaz: Adres kullanımda",
    "Adres": "Adres",

    "ship unload already processed": "Şase tahliye bilgisi zaten işlenmiştir",

    "vehicle is already domestic (milli)": "Araç zaten milli statüsündedir",

    "PASSENGER": "BİNEK",
    "COMMERCIAL": "TİCARİ",
    "HEAVY_COMMERCIAL": "AĞIR TİCARİ",

    "location": "Lokasyon",
    "dealer_code": "Bayi Kodu",
    "company_title": "Firma Ünvanı",
    "group_company_title": "Grupaj Görülecek Firma Ünvanı",
    "brand_id": "Marka",
    "address_definition": "Adres Tarifi",
    "latitude": "Enlem",
    "longitude": "Boylam",
    "phone1": "Telefon 1",
    "distance": "Mesafe",
    "group_region_id": "Grupaj Bölgesi",
    "standard_address_id": "Tanımlı Adres",
    "tax_office": "Vergi Dairesi",
    "tax_number": "Vergi No",
    "coordinates": "Koordinat",
    "phone": "Telefon",
    "excel_data": "Excel ile Gelen Veri",
    "aladin_code_name": "Aladin Kodu/Adı",
    "aladin_code": "Aladin Kodu",
    "aladin_name": "Aladin Adı",
    "tax_info": "Vergi Bilgileri",
    "authorized_info": "Yetkili Bilgileri",
    "email": "E-Posta Bilgileri",
    "special_notes": "Özel Bilgi Açıklama",
    "is_active": "Geçerli",
    "is_warehouse": "Depo Tanımı",
    "save": "Kaydet",
    "cancel": "Vazgeç",
    "dealer_form": "Bayi Formu",
    "field_required": "{field} alanı zorunludur",
    "error_loading_data": "Veri yüklenirken hata oluştu",
    "fill_required_fields": "Lütfen zorunlu alanları doldurunuz",
    "record_created": "Kayıt başarıyla oluşturuldu",
    "record_updated": "Kayıt başarıyla güncellendi",
    "error_occurred": "Bir hata oluştu",

    "No dock permit found for this chassis": "Bu şase için rıhtım isteği bulunamadı",
    "vehicle type: ithal, antrepo: false": "İthal (milli olmayan) araçların çıkış yapabilmesi için antrepo bölgesinde bulunması zorunludur. Antrepo dışında bir bölgede bulunan ithal araçlar çıkış yapamaz.",

    "failed to get groupage details: vehicle not found with the given groupage no": "Verilen grupaj numarası ile araç bulunamadı",

    "Depo Yönetimi": "Depo Yönetimi",
    "Adresteki Araçları Boşalt": "Adresteki Araçları Boşalt",
    "Park Şöförleri": "Park Şöförleri",
    "Emir Tanımlama": "Emir Tanımlama",
    "Araç Yönetimi": "Araç Yönetimi",
    "Sevkiyat Tanımları": "Sevkiyat Tanımları",
    "Taseron Firmalar": "Taseron Firmalar",
    "Sevkiyat Yerleri": "Sevkiyat Yerleri",
    "Sevk Bölgeleri": "Sevk Bölgeleri",
    "Adres Tanımları": "Adres Tanımları",
    "İl Tanımları": "İl Tanımları",
    "İlçe Tanımları": "İlçe Tanımları",
    "Sevkiyat Tipi": "Sevkiyat Tipi",
    "Rota Tanımları": "Rota Tanımları",
    "Sevkiyat KM Bilgileri": "Sevkiyat KM Bilgileri",
    "Araç Markaları": "Araç Markaları",
    "Model Tanımları": "Model Tanımları",
    "Renk Tanımları": "Renk Tanımları",
    "Tanımlamalar": "Tanımlamalar",

    "Veri Yükleme": "Veri Yükleme",
    "Şase Tanımlama": "Şase Tanımlama",
    "Şase Uyarı Yükleme": "Şase Uyarı Yükleme",
    "Gemi Tahliye Bilgisi": "Gemi Tahliye Bilgisi",
    "Gümrüklendi Bilgisi": "Gümrüklendi Bilgisi",
    "PDI Emir Girişi": "PDI Emir Girişi",

    "Fatura Verileri": "Fatura Verileri",
    "Önceliklendirme": "Önceliklendirme",
    "Blokaj/Sevk Emri": "Blokaj/Sevk Emri",
    "Manuel Sevk Emri": "Manuel Sevk Emri",
    "Tekli Grupaj Tır Eşleme": "Tekli Grupaj Tır Eşleme",
    "Gemi Tahliye": "Gemi Tahliye",
    "Gümrüklü Saha Çıkış": "Gümrüklü Saha Çıkış",
    "Sevk Alanına Transfer": "Sevk Alanına Transfer",

    "Depolar Arası Transfer Emri": "Depolar Arası Transfer Emri",
    "Depolar Arası Transfer İzleme": "Depolar Arası Transfer İzlemesi",

    "Grupaj Hazırlama": "Grupaj Hazırlama",
    "Grupaj İşlemleri": "Grupaj İşlemleri",


    "the order to unload the ship must be given first": "Önce gemi tahliye işlemi yapılmalıdır",
    "vehicle in antrepo zone but has no PDI order": "Araç antrepo bölgesinde ancak PDI emri yok",

    "chassis not found": "Şase numarası bulunamadı",
    "failed to check vehicle gorupage status and address: vehicle in groupage": "Araç grupaj statüsünde",

    "failed to get chassis history": "Şase geçmişi alınamadı",
    "no history found for chassis number": "Şase numarası için geçmiş bulunamadı",
    "invalid chassis number length": "Geçersiz şase numarası uzunluğu",
    "must be 17 characters": "17 karakter olmalıdır",

    "COMPLETED": "TAMAMLANDI",
    "WAITING": "BEKLEMEDE",
    "no suitable address found": "Uygun adres bulunamadı",
    "failed to assignToStockArea: no suitable address found": "Uygun adres bulunamadı",

    "öncelikle tır onayı işlemi yapılmalıdır": "Öncelikle Tır Onay işlemi yapılmalıdır",
    "failed to parse address operations": "Adres işlemleri ayrıştırılamadı",
    "unexpected end of JSON input": "Beklenmeyen JSON girişi sonu",
    "vehicle is active": "Araç aktif olarak depoda bulunmaktadır",

    "from_warehouse_id": "Çıkış Depo",
    "to_warehouse_id": "Varış Depo",

    "transfer_date": "Transfer Tarihi",
    "order_id": "Emir ID",
    "customs_clearance.clearance_date:": "Gümrüklendi Tarihi",
    "customs_clearance.clearance_date": "Gümrüklendi Tarihi",
    "ship_unload.unload_date": "Gemi Tahliye Tarihi",
    "dock_permit.permit_date": "Rıhtım İzin Tarihi",
    "failed to get vehicle: vehicle not found": "Araç bulunamadı",
    "vehicle has no current address assignment": "Araçta mevcut adres ataması yok",

    "failed to get reception zone: failed to get zone: no rows in result set": "Bu depoda 'Resepsiyon' bölgesi bulunmamaktadır. Bilgileri kontrol edin.",

    "return.return_date": "İade Tarihi",
    "failed to check vehicle: vehicle not found": "Araç bulunamadı",

    "vehicle is suspended": "Araç resepsiyon bölgesindedir. Ve sistemde tanımlı değildir.",
    "chassis need to be customs clearanced": "Araç millileşme işlemi yapılmalıdır",

    "data SHIP_UNLOAD warehouse_code error: failed to assign chassis to ship area: no rows in result set": "Seçili depo tahliyeye uygun değildir",
    "vehicle has already an order with status waiting": "Araç zaten bekleyen bir emre sahip",

    "no chassis found with number": "Şase numarası ile araç bulunamadı",
    "vehicle is in groupage": "Araç grupaj statüsündedir",

    "warehouse assignment error": "Depo atama hatası",
    "failed to assign chassis to ship area": "şasi gemi alanına atanamadı",
    "no rows in result set": "sonuç setinde satır bulunamadı",
    "warehouse assignment error: failed to assign chassis to ship area: no rows in result set": "Depo atama hatası: şasi gemi alanına atanamadı: sonuç setinde satır bulunamadı",
    "failed to check requesting dealer: order is not from the requested dealer:": "Bayi eşleşmedi edilemedi: emir istenilen bayiden değil",
    "failed to check requesting dealer": "Bayi eşleşmedi edilemedi",
    "order is not from the requested dealer": "emir istenilen bayiden değil",

    "error.invalid_client_code": "Tanımlı olmayan bayi kodu",
    "PDI status is already YENİ": "Aracın pdi emri mevcuttur",
    "merge error": "Birleştirme hatası",
    "The vehicle's dock exit must be ensured": "Araç rıhtım çıkışı yapılmalıdır",
    "domestic vehicles are not allowed for dock enter": "Milli araçlar rıhtıma giriş yapamaz",
    "failed to get vehicle data: vehicle not found": "Araç verisi alınamadı",
    "no invoice or shipping order": "Fatura veya sevkiyat emri bulunamadı",
    "tarih is required and cannot be empty": "Tarih alanı zorunludur ve boş olamaz",
    "failed to transform data": "Veri dönüştürme hatası",
    "vehicle already has dock permit": "Araç zaten Rıhtım Çıkış yapmıştır",
    "updated": "Güncellendi",
    "created": "Eklendi",
}